import { htmlSafe as _htmlSafe } from '@ember/template';
import type { SafeString } from '@ember/template/-private/handlebars';

export default function htmlSafe(text: string): SafeString {
  return _htmlSafe(text);
}
